import React, { AnchorHTMLAttributes } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

import ButtonContent from "./ButtonContent";

import { ButtonVariant, ButtonIconPosition } from "./types";

import styles from "./Button.module.scss";

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  id: string;
  to: string;
  variant?: ButtonVariant;
  isExternal?: boolean;
  iconPosition?: ButtonIconPosition;
  iconComponent?: React.ElementType;
}

const LinkButton = (props: Props) => {
  const {
    to,
    children,
    className,
    variant = "filled",
    isExternal = false,
    iconPosition,
    iconComponent,
    ...otherProps
  } = props;
  const buttonClassName = classnames(styles.button, styles[variant], className);
  const content = (
    <ButtonContent iconPosition={iconPosition} iconComponent={iconComponent}>
      {children}
    </ButtonContent>
  );

  if (isExternal) {
    return (
      <a href={to} className={buttonClassName} {...otherProps}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to} href={to} className={buttonClassName} {...(otherProps as any)}>
      {content}
    </Link>
  );
};

export default LinkButton;
